// extracted by mini-css-extract-plugin
export default {"copyleft-icon":"CEsvGNuK8vKKKKpjkMpo"};